import React from "react";

import {Headings} from "../../../elements/Headings/Headings";
import {Paragraph} from "../../../elements/Paragraph/Paragraph";
import {EcommProductCard} from "../../ProductCard/ProductCard";

export default function ListProductsDefault({ products, settings }) {
    return (
        <div className="default-list">
            <div className={'section-top'}>
                <Headings text={settings.title} type={'h2'}/>
                <Paragraph text={settings.subtext}/>
            </div>

            <div className={'w-full'} x-data="carouselFilter()">
                <div className="row-start-1 col-start-1"
                        x-transition:enter="transition ease-out duration-300"
                        x-transition:enter-start="opacity-0 transform scale-90"
                        x-transition:enter-end="opacity-100 transform scale-100"
                        x-transition:leave="transition ease-in duration-300"
                        x-transition:leave-start="opacity-100 transform scale-100"
                        x-transition:leave-end="opacity-0 transform scale-90">
                    <div className="carousel-item-container w-full" x-data="carousel()">
                        <div className="carousel w-full" x-ref="carousel">
                            {products.map((product, id) => (
                                <div key={id} className="carousel-item">
                                    <EcommProductCard
                                        product={product.product}
                                        swatches={product.product.swatches}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}